import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { StudyDetailsDrawerQuery, StudyDetailsDrawerQueryVariables } from '@/shared/api';
import STUDY_DETAILS_DRAWER_QUERY from '../queries/studyDetailsDrawer';

/**
 * Loads the study fields rendered in the study details drawer. Runs STUDY_DETAILS_DRAWER_QUERY and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the study to load.
 * @returns The study record for the drawer.
 */
const fetchStudyDetailsDrawer = async (id: any) => {
  const client = createClient();
  const studyResult = await client.query<StudyDetailsDrawerQuery, StudyDetailsDrawerQueryVariables>(
    {
      query: STUDY_DETAILS_DRAWER_QUERY,
      variables: {
        id,
      },
    },
  );
  const { data, errors } = studyResult;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return study;
};

export default fetchStudyDetailsDrawer;
